<template>
  <div class="modal custom-modal fade" id="edit-schedule-template-user" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
         <div class="modal-header">
          <h5 class="modal-title">Edit Schedule Users</h5>
          <button type="button" ref="Close" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          
            <v-select v-model="assginedUserIds" :items="userData" item-title="name" item-value="id"
              placeholder="select Users" multiple chips closable-chips return-object variant="outlined" >
            </v-select>
            <div class="input-block mb-3 mt-3">
              <label class="col-form-label">Effective Date</label>
              <div class="cal-icon">
                <date-picker :inputFormat="'dd/MM/yyyy'" placeholder="Choose Date" class="form-control datetimepicker" :editable="true"
                  :clearable="false" v-model="effectiveDate" />
              </div>
              <small class="text-muted">Schedules will be regenerated from this date. Can be up to 1 month in the past.</small>
            </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-primary continue-btn" @click="updateUserSchedule"> <span v-if="!isLoading">Submit</span>
                <div class="spinner-border spinner-border-sm text-light" role="status" v-else>
                  <span class="visually-hidden">Loading...</span>
                </div></a>
              </div>
              <div class="col-6">
                <a href="javascript:void(0);" data-bs-dismiss="modal" class="btn btn-primary cancel-btn">Cancel</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import axios from 'axios';
import dayjs from "dayjs";
import {VUE_APP_API_BASE_URL} from "../../config";
export default {
  data() {
    return {
      assginedUserIds: [],
      userData: [],
      templateId:'',
      isLoading:false,
      effectiveDate: new Date()
    };
  },
  mounted() {
      this.getUsersData()
      
  },
  methods: {
    updateId(record){
      this.templateId = record;
      this.getTemplateAssignedUsers();
    },
     

    async getTemplateAssignedUsers() {
      await axios.get(`${VUE_APP_API_BASE_URL}/schedule-template/${this.templateId}/assigned-users`)
        .then((response) => {
          if (response.data.status) {
             
            this.assginedUserIds = response.data.data;
             this.assginedUserIds.forEach(element => {
              element['name'] = element['first_name'] + ' ' + element['last_name'];
              delete element['first_name'];
              delete element['last_name'];
            },)

          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },
    async getUsersData() {
      await axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.userData = response.data.data
            this.userData.forEach(element => {
              element['name'] = element['first_name'] + ' ' + element['last_name'];
              delete element['first_name'];
              delete element['last_name'];
            },
              );
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },
    updateUserSchedule() {
      this.isLoading = true;
      var ids = []
      this.assginedUserIds.forEach(element => {
              ids.push(element.id);
            });
      
      var Shift = {
        "schedule_template_id": this.templateId,
        "assgined_user_ids": ids,
        "effective_date": this.effectiveDate ? dayjs(this.effectiveDate).format("YYYY-MM-DD") : null
      }
      
      axios.post(`${VUE_APP_API_BASE_URL}/schedule-template/update-user`, Shift)
        .then((response) => {
          if (response.data.status) {
            this.$toast.success(response.data.message);
            this.$emit("editedShift");
            this.$refs.Close.click();
            this.isLoading = false;
          } else {
            this.$toast.error(response.data.message || response.data.errors);
            this.isLoading = false;
            // this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.isLoading = false;
        });

    }
  }
};
</script>
